<div class="h-full flex min-h-0 flex-col overflow-hidden">
  @if (tieneTelefonos() === null) {
    <div class="flex-1 flex items-center justify-center">
      <div class="flex flex-col items-center gap-3 text-slate-400">
        <i class="bi bi-hourglass-split text-4xl animate-spin"></i>
        <p class="text-sm">Cargando...</p>
      </div>
    </div>
  } @else if (tieneTelefonos() === false) {
    <div class="flex-1 flex items-center justify-center p-6">
      <div class="flex flex-col items-center gap-4 max-w-md text-center">
        <div class="flex h-16 w-16 items-center justify-center rounded-full bg-amber-50">
          <i class="bi bi-exclamation-triangle text-amber-500 text-3xl"></i>
        </div>
        <h3 class="text-lg font-semibold text-slate-800">No hay teléfonos configurados</h3>
        <p class="text-sm text-slate-500 leading-relaxed">
          Para usar MicaChat, solicita al administrador de VentaClick que agregue un número de
          teléfono para esta sucursal. Una vez configurado, podrás gestionar todas tus
          conversaciones de WhatsApp desde aquí.
        </p>
        <div class="flex items-center gap-2 rounded-lg bg-blue-50 px-4 py-2 text-sm text-blue-700">
          <i class="bi bi-info-circle"></i>
          <span>Contacta al administrador del sistema</span>
        </div>
      </div>
    </div>
  } @else {
    <app-mica-chat-header
      [telefonos]="telefonos()"
      [(vistaActiva)]="vista"
      (telefonoCambiado)="onTelefonoCambiado($event)"
    />

    @switch (vista()) {
      @case ('chats') {
        <div class="flex-1 min-h-0">
          <app-micachat-chats />
        </div>
      }
      @case ('configuracion') {
        <app-mica-chat-configuracion
          [telefonos]="telefonos()"
          (toggleComprobantes)="toggleComprobantes($event)"
        />
      }
      @case ('flujos') {
        <app-mica-chat-flujos />
      }
      @case ('campanas') {
        <app-mica-chat-campanas />
      }
    }
  }
</div>
